module.exports = __webpack_public_path__ + "fonts/roboto-v27-latin-ext_latin-regular.671b8a3.woff2";